export default __webpack_public_path__ + "static/media/me.6f590cbb.png";